module.exports = __webpack_public_path__ + "static/media/003.33b397a8.jpg";